// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","mobileThreshold":"575px","textBlack":"#161616","container":"_7q1ucHSoBSk7BN6OJWN_Q","splashLogo":"YRPMQ6t7nBMiu6RhnD6wJ","homeLink":"_1607BMXT3G2xwFxKnyjayv"};


//////////////////
// WEBPACK FOOTER
// ./src/common/error-handler/ErrorHandler.css
// module id = 259
// module chunks = 0 1 2